// 任务状态
const taskSatus = [
    {
        value: 5,
        label: '待审批'
    },
      {
        value: 8,
        label: '审批拒绝'
    },
    {
        value: 10,
        label: '待取货'
    },
    {
        value: 20,
        label: '完成取货'
    },
    {
        value: 90,
        label: '任务完成'
    }
]
// 计划状态
const planStatus = [
    {
        value: 10,
        label: '规划中'
    },
    {
        value: 15,
        label: '已提交/待环境确认'
    },
    {
        value: 20,
        label: '待审核'
    },
    {
        value: 30,
        label: '环境保障驳回'
    },
    {
        value: 31,
        label: '审批拒绝'
    },
    {
        value: 40,
        label: '审核通过'
    },
    {
        value: 50,
        label: '待飞行'
    },
    {
        value: 60,
        label: '正在飞行'
    },
    {
        value: 70,
        label: '飞行结束'
    },
    {
        value: 90,
        label: '确认收货'
    },
]
// 密级
const secrecyStatus = [
    {
        value: 0,
        label: '非' + '密'
    },
    {
        value: 1,
        label: '秘' + '密'
    },
    {
        value: 2,
        label: '机'+ '密'
    },
    {
        value: 3,
        label: '绝' + '密'
    }
]
// 类型
const typeStatus = [
    {
        value: 1,
        label: '弹药'
    },
    {
        value: 2,
        label: '食品'
    },
    {
        value: 3,
        label: '药品'
    }
]
// 包装
const packageStatus = [
    {
        value: 1,
        label: '冷冻'
    },
    {
        value: 2,
        label: '密封塑料箱'
    },
    {
        value: 3,
        label: '塑料袋'
    }
]

export {
    taskSatus,
    planStatus,
    secrecyStatus,
    typeStatus,
    packageStatus
}


// WEBPACK FOOTER //
// ./src/common/dictionary.js